$(document).ready(function () {

  if (!$("#kshipit").length) return;

  $(".tickbtn").on("click", function () {

    var pincode = $("#chkpin").val().trim();

    var isIndiaFormat = /^[1-9][0-9]{5}$/.test(pincode);
    var isRepeated = /^(\d)\1{5}$/.test(pincode); // 111111, 222222 etc

    /* ❌ Empty */
    if (!pincode) {
      $(".pincodersltpre").html(
        '<p class="msgstyle error">Please enter a pincode.</p>'
      );
    }

    /* ❌ Invalid / Fake / Non-India */
    else if (!isIndiaFormat || isRepeated) {
      $(".pincodersltpre").html(
        '<p class="msgstyle error">❌ Sorry, delivery is not available for pincode <strong>' +
        pincode +
        '</strong>.</p>'
      );
    }

    /* 📦 VALID INDIA PIN */
    else {
      $(".pincodersltpre").html(
        '<p class="msgstyle warning">📦 Standard delivery available in <strong>6-8 days</strong>.</p>'
      );
    }

    $("#pinresult").show();
  });

});
